<app-mit-form 
    [formGroup]="formGroup" 
    [dialogFields]="dialogFields" 
    [callback]="callback"
    [enablePreUpload]="enablePreUpload"
    (closeEvent)="closeEvent()"
    (cancelEvent)="cancelEvent()"
    ></app-mit-form>